
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ConsultantBarometerQuestionPhrases, RotationTermPhrases } from '../../shared/configuration/BarometerConfig';
import {
    AnswerType,
    IAnswerDatum,
    IAnswerHypermediaRepresentation
} from '../../shared/contracts/AnswerContract';
import { ISnapshotHypermediaRepresentation } from '../../shared/contracts/SnapshotContract';
import { logService } from '../../shared/services/LogService';
import Collapsible from '../shared/Collapsible.vue';
import Answer from './Answer.vue';
import AnswerTrend from './AnswerTrend.vue';
import { BarometerTab } from './BarometerModel';

@Component({
    components: {
        AnswerTrend,
        Answer,
        Collapsible
    }
})
export default class Snapshot extends Vue {
    @Prop() snapshot: ISnapshotHypermediaRepresentation;
    private questionPhrases = ConsultantBarometerQuestionPhrases;

    @Prop() growthEvolution: IAnswerDatum[];

    @Prop() networkEvolution: IAnswerDatum[];

    @Prop() projectEvolution: { [key: string]: IAnswerDatum[] };

    @Prop() rotationEvolution: {[key: string]: IAnswerDatum[]};

    @Prop() selectedTab: BarometerTab;

    private rotationTermPhrases = RotationTermPhrases;


    get sortedAnswers(): IAnswerHypermediaRepresentation[] {
        let result = this.snapshot.answers.filter(a => a.answerType === AnswerType.Project);
        result.push(...this.snapshot.answers.filter(a => a.answerType === AnswerType.Growth));
        result.push(...this.snapshot.answers.filter(a => a.answerType === AnswerType.Network));
        result.push(...this.snapshot.answers.filter(a => a.answerType === AnswerType.Rotation));
        return result;
    }

    answerHistory(a: IAnswerHypermediaRepresentation) {
        if (a) {
            switch (a.answerType) {
                case AnswerType.Network:
                    return this.networkEvolution;
                case AnswerType.Growth:
                    return this.growthEvolution;
                case AnswerType.Project:
                    return this.projectEvolution[a.accountId];
                case AnswerType.Rotation:
                    return this.rotationEvolution[a.accountId];
            }
            logService.logError('Could not map ' + a.answerType + ' to a history list');
        }
        return [];
    }

    selectSnapshotId(snapshotId: number) {
        this.$emit('selectSnapshotId', snapshotId);
    }

    dataUpdated() {
        this.$emit('dataUpdated');
    }
}
